<!--
 * @Description: 我的评价学生列表
 * @Author: 烟雨
 * @Date: 2022-04-02 09:38:29
 * @LastEditors: 烟雨
 * @LastEditTime: 2022-04-12 13:55:22
-->
<template>
  <div>
    <div
      class="bg-FFFFFF pt-8 fb fb-cross-start"
      v-for="(item, index) in evaluationList"
      :key="`${index}`"
    >
      <div
        class="inline-block mt-4 w-36 h-36 bd-p-50 font-22 mr-12 indent0 lh-14 text-center"
      >
        <div
          class="width-full height-full fb fb-cross-center fb-main-center"
          :class="{
            'default-icon': +item.iconType !== 3 && !item.evaluationItemPic
          }"
        >
          <img
            class="b-radius-50"
            v-if="item.evaluationItemPic"
            key="pic"
            :src="item.evaluationItemPic"
          />
          <img
            v-else-if="+item.iconType === 3"
            key="wordComment"
            src="./../assets/images/comment.png"
          />
          <div
            class="font-22 fb fb-cross-center fb-main-center ff-medium c-FFFFFF"
            v-else
            v-html="formatGroupItemName(item)"
          ></div>
        </div>
      </div>
      <div
        class="item-flex-1 bb pr-16 pb-12"
        v-if="type === 'teacher'"
        key="teacher"
      >
        <div
          v-show="+item.iconType !== 3"
          class="font-34 c-171A1D lh-24 fb fb-cross-center fb-main-between"
        >
          <div class="fb fb-cross-center">
            <span class="inline-block text-ellipsis max-w-150 pr-5">
              {{ item.studentName }}
            </span>
            <span> {{ item.moralEduEvaluationItemName }}</span></div
          >
          <span :class="+item.iconType === 1 ? 'c-006AFE' : 'c-171A1D-85'">
            {{ itemScore(item) }}
          </span>
        </div>
        <p
          v-show="+item.iconType === 3 && item.wordComment"
          class="font-34 c-171A1D lh-24"
        >
          {{ item.studentName }} &nbsp; {{ item.wordComment }}
        </p>
        <div class="fb fb-cross-center fb-main-between font-24 c-171A1D-40">
          <span>{{ item.className }}</span>
          <span>{{ timeFormat(new Date(+item.gmtCreate), 'YYYY.MM.DD') }}</span>
        </div>
      </div>
      <div
        class="item-flex-1 bb pr-16 pb-12"
        v-else-if="type === 'student'"
        key="student"
      >
        <p class="font-34 c-171A1D lh-24 fb fb-main-between">
          {{
            item.moralEduEvaluationItemName
              ? `${item.moralEduEvaluationItemName} ${itemScore(item)}`
              : '图文点评'
          }}
          <span
            class="font-28 c-006AFE"
            v-if="
              item.teacherDingId === dingUserId &&
              item.isToday &&
              allowDelete &&
              (curIsAdmin || curIsCampusHeadmaster || curIsMeTeacher)
            "
            @click="handleDelete(item)"
            >删除</span
          >
        </p>
        <p class="font-28 c-171A1D-40">
          {{ timeFormat(new Date(+item.gmtModify), 'YYYY.MM.DD hh:mm') }}
          {{ filterName(item.teacherName, 8) }}老师点评
        </p>
        <div
          class="comment-con mt-12"
          v-if="item.wordComment || item.remark || (item.picUrls || []).length"
        >
          <div class="comment font-28" v-if="item.remark || item.wordComment">
            <div class="desc c-171A1D">文字点评</div>
            <div class="comment-text c-171A1D-56 break-all">{{
              item.remark || item.wordComment
            }}</div>
          </div>
          <common-upload-img
            class="mt-8"
            v-if="(item.picUrls || []).length"
            :imgs="item.picUrls"
            :showOnly="true"
          ></common-upload-img>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from '@/mixin'
import commonUploadImg from './commonUploadImg.vue'
import { timeFormat, filterName } from '@/utils/comUtils'
export default {
  name: 'evaluationRecordsList',
  mixins: [mixin],
  components: {
    commonUploadImg
  },
  props: {
    // student 展示学生看到的考评
    type: {
      type: String,
      default: 'teacher'
    },
    evaluationList: {
      type: Array,
      default: () => []
    },
    allowDelete: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      filterName,
      timeFormat
    }
  },
  computed: {
    dingUserId() {
      return (this.$store.getters.token || {}).userid || ''
    }
  },
  methods: {
    itemScore(item) {
      let _score = ''
      switch (+item.iconType) {
        case 1:
          _score =
            item.moralEduEvaluationItemScore > 0
              ? `+${item.moralEduEvaluationItemScore}`
              : item.moralEduEvaluationItemScore
          break
        case 2:
          _score = item.moralEduEvaluationItemScore
          break
        case 3:
          _score =
            item.moralEduEvaluationItemScore > 0
              ? `+${item.moralEduEvaluationItemScore}`
              : item.moralEduEvaluationItemScore
          break
      }
      return _score
    },
    // 单项名称无图时默认展示前2字
    formatGroupItemName({ moralEduEvaluationItemName } = {}) {
      if (!moralEduEvaluationItemName) {
        return ''
      }
      return `<div><p>${moralEduEvaluationItemName.slice(0, 2)}</p></div>`
    },
    handleDelete(item) {
      this.$emit('deleteRecord', item)
    }
  }
}
</script>

<style lang="scss" scoped>
.default-icon {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: rgba(0, 176, 66, 0.48);
}
.b-radius-50 {
  border-radius: 50%;
}
.comment-con {
  width: 100%;
  background: #f2f2f6;
  border-radius: 8px;
  padding: 16px;
  .comment-text {
    background: rgba(23, 26, 29, 0.04);
    border-radius: 8px;
    padding: 8px 16px;
    margin-top: 12px;
  }
  :deep(.img-item) {
    margin-top: 0;
    margin-bottom: 0;
  }
}
</style>
